// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export class Rect {
    static intersects(a: Rect, b: Rect) {
        return (
            a.left <= b.left + b.width &&
            b.left <= a.left + a.width &&
            a.top <= b.top + b.height &&
            b.top <= a.top + a.height
        )
    }

    constructor(
        public left: number = 0,
        public top: number = 0,
        public width: number = 0,
        public height: number = 0
    ) {}

    containsPoint(x: number, y: number): boolean {
        return (
            this.left <= x &&
            x <= this.right &&
            this.top <= y &&
            y <= this.bottom
        )
    }

    containsRect(r: ClientRect): boolean {
        return (
            this.left <= r.left &&
            this.right >= r.right &&
            this.top <= r.top &&
            this.bottom >= r.bottom
        )
    }

    get right(): number {
        return this.left + this.width
    }

    set right(value: number) {
        this.left = value - this.width
    }

    get bottom(): number {
        return this.top + this.height
    }

    set bottom(value: number) {
        this.top = value - this.height
    }

    equals(value: ClientRect): boolean {
        return (
            this.left === value.left &&
            this.top === value.top &&
            this.width === value.width &&
            this.height === value.height
        )
    }

    clone(): Rect {
        return new Rect(this.left, this.top, this.width, this.height)
    }

    scaleAbout(factor: number, origin: { x: number; y: number }) {
        this.width = this.width * factor
        this.height = this.height * factor
        const scaleTop = origin.y - this.top
        const scaleLeft = origin.x - this.left
        this.top = origin.y - scaleTop * factor
        this.left = origin.x - scaleLeft * factor
        return this
    }
}
